import React from 'react';
import { motion } from 'framer-motion';
import styles from './AmbientBlobs.module.css';

export interface BlobConfig {
  gradient: string;
  position: React.CSSProperties;
  size: number;
  duration?: number;
  delay?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  animate?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transition?: any;
}

interface AmbientBlobsProps {
  blobs: BlobConfig[];
}

export function AmbientBlobs({ blobs }: AmbientBlobsProps) {
  return (
    <>
      {blobs.map((blob, i) => (
        <motion.div
          key={i}
          className={styles.blob}
          style={{
            width: blob.size,
            height: blob.size,
            background: blob.gradient,
            ...blob.position,
          }}
          animate={blob.animate ?? { scale: [1, 1.1, 1], opacity: [0.4, 0.65, 0.4] }}
          transition={blob.transition ?? {
            repeat: Infinity,
            duration: blob.duration ?? 6,
            ease: 'easeInOut',
            delay: blob.delay ?? 0,
          }}
        />
      ))}
    </>
  );
}
